// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  font-family: \"Lato\",\"Avenir\",\"Adobe Heiti Std\",\"Segoe UI\",\"Trebuchet MS\",sans-serif;\n}\n\na {\n  text-decoration: none;\n}\n\nimg {\n  height: auto;\n  max-width: 100%;\n}\n\n", ""]);
// Exports
module.exports = exports;
